import React, { useState, useMemo } from 'react';

const FOLDERS = ["Order", "Invoice", "Delivery Notes", "Packing List"];

const getFileIcon = (fileName = "") => {
    const ext = fileName.split(".").pop()?.toLowerCase();
    switch (ext) {
        case "pdf": return "fas fa-file-pdf";
        case "doc":
        case "docx": return "fas fa-file-word";
        case "xls":
        case "xlsx": return "fas fa-file-excel";
        case "jpg":
        case "jpeg":
        case "png": return "fas fa-file-image";
        default: return "fas fa-file";
    }
};

const ViewDocuments = ({ attachments = [] }) => {
    const [activeFolder, setActiveFolder] = useState(FOLDERS[0]);

    const filesInActiveFolder = useMemo(
        () => attachments.filter(doc => doc.category === activeFolder),
        [attachments, activeFolder]
    );

    if (!attachments.length) {
        return (
            <>
                <div className="card-header">
                    <h1>Documents</h1>
                </div>
                <div className="card-body">
                    <p>No documents available.</p>
                </div>
            </>
        );
    }

    return (
        <>
            <div className="card-header">
                <h1>Documents</h1>
            </div>
            <div className="card-body">
                <div className="row">
                    <div className="col-md-12">
                        <div className="d-flex justify-content-start document-folder">
                            {FOLDERS.map(folder => (
                                <div
                                    className="text-center"
                                    key={folder}
                                    style={{ cursor: "pointer" }}
                                    onClick={() => setActiveFolder(folder)}
                                >
                                    <i
                                        className={
                                            activeFolder === folder ? "fas fa-folder-open" : "fas fa-folder"
                                        }
                                    ></i>
                                    <p>{folder}</p>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="col-md-12 mt-5">
                        <div className="d-flex justify-content-start document-names">
                            {filesInActiveFolder.length ? (
                                filesInActiveFolder.map(doc => (
                                    <div className="text-center" key={doc.id}>
                                        <a href={doc.fileUrl} target="_blank" rel="noopener noreferrer">
                                            <i className={getFileIcon(doc.fileName)}></i>
                                        </a>
                                        <p className="mt-3">{doc.fileName}</p>
                                    </div>
                                ))
                            ) : (
                                <p>No files in this folder.</p>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ViewDocuments;